import { render } from "./VerifyBody.vue?vue&type=template&id=23b2dc08"
import script from "./VerifyBody.vue?vue&type=script&lang=js"
export * from "./VerifyBody.vue?vue&type=script&lang=js"

import "./VerifyBody.vue?vue&type=style&index=0&id=23b2dc08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__